/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import {
    ResponsiveMode as FabricResponsiveMode,
    IWithResponsiveModeState,
    withResponsiveMode as fabricWithResponsiveMode
} from '@fluentui/react';
import * as React from 'react';

export type ResponsiveModeProps = IWithResponsiveModeState;
export type ResponsiveModeType = FabricResponsiveMode;

/**
 * A value representing the current screen size.
 */
export const ResponsiveMode = FabricResponsiveMode;

/**
 * A wrapper around Fabric's withResponsiveMode that provides typing.
 */
export function withResponsiveMode<P extends ResponsiveModeProps>(comp: React.ComponentType<P>) {
    return <React.ComponentClass<Omit<P, keyof ResponsiveModeProps>>>fabricWithResponsiveMode(<any>comp);
}
